export const isValueEditorObject = (value) => {
  return Boolean(value.entityMap);
};
